/* eslint-disable */
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import NotificationDropdown from "components/Dropdowns/NotificationDropdown.js";
import UserDropdown from "components/Dropdowns/UserDropdown.js";
import { FaUserCircle } from "react-icons/fa";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { imageBaseURL } from "../../actions/Base_URL";

const menuItems = [
  {
    label: "Events",
    icon: "fas fa-calendar-alt",
    to: "/admin/events",
    roles: ["admin", "student"],
  },
  {
    label: "Facilities",
    icon: "fas fa-file-alt",
    to: "/admin/facilities",
    roles: ["admin", "student", "office manager"],
  },
  {
    label: "Facility Reservation",
    icon: "fas fa-tools",
    to: "/admin/facility-reservation",
    roles: ["admin", "office manager"],
  },
  {
    label: "Inventory",
    icon: "fas fa-box",
    to: "/admin/inventory",
    roles: ["admin", "student", "labincharge"],
  },
  {
    label: "Inventory Booking",
    icon: "fas fa-tasks",
    to: "/admin/assign-inventory",
    roles: ["admin", "labincharge", "student"],
  },
  {
    label: "Labs",
    icon: "fas fa-flask",
    to: "/admin/labs",
    roles: ["admin"],
  },
  {
    label: "Lab Incharge",
    icon: "fas fa-user-tie",
    to: "/admin/lab-incharge",
    roles: ["admin"],
  },
  {
    label: "Clubs",
    icon: "fas fa-users-cog",
    to: "/admin/clubs",
    roles: ["admin"],
  },
  {
    label: "Users",
    icon: "fas fa-users",
    to: "/admin/users",
    roles: ["admin"],
  },
  {
    label: "Admins",
    icon: "fas fa-user-shield",
    to: "/admin/admins",
    roles: ["admin"],
  },
  {
    label: "Profile",
    icon: "profile",
    to: "/admin/settings",
    roles: ["admin", "student", "office manager"],
  },
  {
    label: "Portal Images",
    icon: "fas fa-images",
    to: "/admin/portal-images",
    roles: ["admin"],
  },
  {
    label: "Blogs",
    icon: "fas fa-blog",
    to: "/admin/blogs",
    roles: ["admin"],
  },
  {
    label: "Galleries",
    icon: "fas fa-photo-video",
    to: "/admin/galleries",
    roles: ["admin"],
  },
  {
    label: "Members",
    icon: "fas fa-id-card",
    to: "/admin/members",
    roles: ["admin"],
  },
  {
    label: "MPDI/PDI Projects",
    icon: "fas fa-project-diagram",
    to: "/admin/projects",
    roles: ["admin", "student"],
  },
  {
    label: "App Links",
    icon: "fas fa-link",
    to: "/admin/links",
    roles: ["admin"],
  },
  {
    label: "Head's Desk",
    icon: "fas fa-user-tie",
    to: "/admin/headdesk",
    roles: ["admin"],
  },
];

export default function Sidebar() {
  const [collapseShow, setCollapseShow] = React.useState("hidden");
  const navigate = useNavigate();

  const getRole = () => {
    const token = localStorage.getItem("token");
    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      return decoded.role?.toLowerCase();
    } catch {
      return null;
    }
  };

  const userRole = getRole();
  const [logoUrl, setLogoUrl] = React.useState("https://nvcti.iitism.ac.in/assets/images/logo/logo-dark.png");

  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const response = await axios.get("https://api.nvcti.in/api/images/images?type=logo");
        let images = [];
        if (response.data && Array.isArray(response.data.images)) {
          images = response.data.images;
        } else if (Array.isArray(response.data)) {
          images = response.data;
        } else if (response.data && Array.isArray(response.data.data)) {
          images = response.data.data;
        }

        if (images.length > 0) {
          const firstLogo = images[0];
          if (firstLogo.path) {
            setLogoUrl(`${imageBaseURL}${firstLogo.path}`);
          }
        }
      } catch (error) {
        console.error("Failed to fetch logo:", error);
      }
    };
    fetchLogo();
  }, []);

  const handleLogout = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      .swal2-popup.custom-swal-popup {
        box-shadow: none !important;
        border: 1px solid #1e3a5f !important;
        background: #0f2847 !important;
        padding: 20px !important;
        position: relative;
        color: #e8eef4 !important;
      }
      .swal2-title, .swal2-html-container {
        color: #e8eef4 !important;
      }
      .swal2-close {
        position: absolute !important;
        top: 5px !important;
        right: 10px !important;
        font-size: 2rem !important;
        width: 2.0rem !important;
        height: 2.0rem !important;
        line-height: 2.5rem !important;
        color: #94a3b8 !important;
        z-index: 1000 !important;
      }
      .swal2-close:hover {
        color: #e8eef4 !important;
      }
    `;
    document.head.appendChild(style);

    Swal.fire({
      html: ReactDOMServer.renderToString(
        <div className="flex flex-col items-center justify-center text-gray-200">
          <FontAwesomeIcon
            icon={faSignOutAlt}
            style={{ fontSize: "40px", color: "#dc2626", marginBottom: "10px" }}
          />
          <h2 className="text-xl font-semibold mb-2" style={{ color: "#e8eef4" }}>Are you sure?</h2>
          <p style={{ color: "#94a3b8" }}>Do you really want to log out?</p>
        </div>
      ),
      customClass: {
        popup: "custom-swal-popup",
      },
      background: "#0f2847",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#dc2626",
      cancelButtonColor: "#3b82f6",
      confirmButtonText: ReactDOMServer.renderToString(
        <>
          Yes, log out
          <FontAwesomeIcon icon={faSignOutAlt} style={{ marginLeft: "10px" }} />
        </>
      ),
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Logged Out",
          text: "You have been successfully logged out.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
          background: "#0f2847",
          color: "#e8eef4",
        });
        setTimeout(() => {
          localStorage.removeItem("token");
          navigate("/auth/login");
        }, 500);
      }
    });
  };



  return (
    <>
      <nav className="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-dark-secondary flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6 border-r border-dark-tertiary">
        <div className="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto">
          <button
            className="cursor-pointer text-gray-200 opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
            type="button"
            onClick={() => setCollapseShow("bg-dark-secondary m-2 py-3 px-6")}
          >
            <i className="fas fa-bars"></i>
          </button>

          <Link
            className="md:block text-left md:pb-2 text-gray-200 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
            to="/"
          >
            <img src={logoUrl} alt="NVCTI Logo" className="h-12 inline-block -mt-1" style={{ maxWidth: "200px" }} />
          </Link>

          <ul className="md:hidden items-center flex flex-wrap list-none">
            <li className="inline-block relative">
              <NotificationDropdown />
            </li>
            <li className="inline-block relative">
              <UserDropdown />
            </li>
          </ul>

          <div
            className={
              "md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-4 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded " +
              collapseShow
            }
          >
            <div className="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-dark-tertiary">
              <div className="flex flex-wrap">
                <div className="w-6/12">
                  <Link
                    className="md:block text-left md:pb-2 text-gray-200 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                    to="/"
                  >
                    <img src={logoUrl} alt="NVCTI Logo" className="h-10 inline-block -mt-1" style={{ maxWidth: "150px" }} />
                  </Link>
                </div>
                <div className="w-6/12 flex justify-end">
                  <button
                    type="button"
                    className="cursor-pointer text-gray-200 opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                    onClick={() => setCollapseShow("hidden")}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>

            <hr className="my-4 md:min-w-full border-dark-tertiary" />

            <ul className="md:flex-col md:min-w-full flex flex-col list-none">
              {menuItems.map((item) => {
                if (!item.roles.includes(userRole)) return null;

                const isActive = window.location.href.includes(item.to);
                const textColor = isActive
                  ? "text-accent-primary hover:text-accent-hover"
                  : "text-gray-300 hover:text-gray-100";
                const iconColor = isActive ? "text-accent-primary" : "text-gray-500";

                return (
                  <li key={item.to} className="items-center">
                    <Link
                      className={`text-xs uppercase py-3 font-bold ${textColor} flex items-center transition-colors`}
                      to={`/${userRole}${item.to.replace(
                        /^\/(admin|student|office manager)/,
                        ""
                      )}`}
                    >
                      {item.icon === "profile" ? (
                        <FaUserCircle className={`mr-2 text-xl ${iconColor}`} />
                      ) : (
                        <i
                          className={`${item.icon} mr-2 text-sm ${iconColor}`}
                        ></i>
                      )}
                      {item.label}
                    </Link>
                  </li>
                );
              })}

              <li className="items-center">
                <button
                  onClick={handleLogout}
                  className="text-xs uppercase py-3 font-bold text-red-500 hover:text-red-400 flex items-center border-none outline-none focus:outline-none transition-colors"
                >
                  <i className="fas fa-sign-out-alt mr-2 text-sm text-gray-500"></i>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
